var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 9.79997H1.2C0.537258 9.79997 0 9.26271 0 8.59997V1.34777C0.027965 0.705496 0.55712 0.199359 1.2 0.199967H10.8C11.4627 0.199967 12 0.737226 12 1.39997V8.59997C12 9.26271 11.4627 9.79997 10.8 9.79997ZM1.2 2.52077V8.59997H10.8V2.52077L6 5.71997L1.2 2.52077ZM1.68 1.39997L6 4.27997L10.32 1.39997H1.68Z",
    fill: "url(#paint0_linear_385_15217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_15217",
    x1: 6,
    y1: 0.199966,
    x2: 6,
    y2: 9.79997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.854cf9ec59627ce90c2c8c8dba8976dd.svg";
export { ForwardRef as ReactComponent };